import { useCallback, useEffect, useState } from "react";
import { useSession } from "@/context/SessionContext";
import { errMsg } from "@/lib/format";

export function useFetch(path, params, enabled = true) {
  const { api, scopeKey } = useSession();
  const [s, setS] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(params || {});

  const load = useCallback(async () => {
    if (!enabled) {
      setS({ data: null, loading: false, error: null });
      return;
    }
    setS((p) => ({ ...p, loading: true, error: null }));
    try {
      const { data } = await api.get(path, { params: JSON.parse(key) });
      setS({ data, loading: false, error: null });
    } catch (e) {
      setS({ data: null, loading: false, error: errMsg(e) });
    }
  }, [api, path, key, scopeKey, enabled]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    load();
  }, [load]);

  return { ...s, reload: load };
}
